import { AsyncState, HttpResult } from "widgets-for-react"

declare global {
  interface Window {
    kioskCredentials: {
      Username: string
      Password: string
    }
  }
}

export const defaultHeaders = () => {
  let headers = new Headers()
  headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)
  if (window.kioskCredentials) {
    headers.append('Authorization', `Basic ${btoa(window.kioskCredentials.Username + ':' + window.kioskCredentials.Password)}`)
  }
  return headers
}

export const defaultGetOptions: () => RequestInit = () => ({
  method: 'GET',
  credentials: 'include',
  headers: defaultHeaders()
})

export const handle = async <AppResult>(
  res: Response,
  converter?: (input: unknown) => AppResult
): Promise<HttpResult<AppResult>> => {
  if (400 <= res.status && res.status < 500) return { kind: 'unauthorized', status: res.status };
  if (res.status >= 500) return { kind: 'failed', status: res.status };

  const apiResult = await res.json();

  const result: HttpResult<AppResult> = {
    kind: 'result',
    status: 200,
    value: converter ? converter(apiResult) : (apiResult as unknown as AppResult)
  };

  return result;
};

export const previousOrDefault = <A>(asyncState: AsyncState<A>, defaultValue: A) => asyncState.kind == 'loaded' ? asyncState.value : defaultValue

export const ready =
  <A>(asyncState: AsyncState<A>): asyncState is AsyncState<A> & { kind: 'loaded' | 'loading' } =>
    asyncState.kind == 'loaded' || asyncState.kind == 'loading'

export const transitionedToLoaded =
  <A>(from: AsyncState<A>, to: AsyncState<A>): to is AsyncState<A> & { kind: 'loaded' } =>
    from.kind != 'loaded' && to.kind == 'loaded'

// During development, the Kiosk is showing the acceptance environment which is protected via Basic Auth
// The Kiosk is unable to pass basic auth as a header, so it uses basic auth in the URL
// This works for the document request, but breaks for subsequent API requests
// This function removes the URL based basic auth, which is later on replaced by a header
export const cleanFetch = (input: string, init?: RequestInit): Promise<Response> => fetch(location.origin + input, init)

export const genericGet = <AppResult>(endpoint: string, converter?: (input: unknown) => AppResult) => async (): Promise<HttpResult<AppResult>> => {
  const response = await cleanFetch(endpoint, defaultGetOptions())

  const temp = await handle<AppResult>(response, converter)
  if (temp.kind != 'result') return (temp as HttpResult<AppResult>)
  return { ...temp, value: temp.value }
}